// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__13g39","header":"MergedInvoice_header__3TT1Q"};